import React from 'react';
import { FunctionPermissions, MovementType } from '../../../../../../types/types';

type RequestMotionItemProps = {
  item: MovementType;
  permissions: FunctionPermissions;
};

export const RequestMotionItem = ({ item, permissions }: RequestMotionItemProps) => (
  <>
    {item?.operationComment && <div>Комментарий: {item.operationComment}</div>}
    {item?.permissionNumber && <div>Номер разрешения ЕРУЛ: {item.permissionNumber}</div>}
    {item?.permissionDate && <div>Дата выдачи разрешения ЕРУЛ: {item.permissionDate}</div>}
    {item?.permissionValidDate && <div>Срок действия разрешения: {item.permissionValidDate}</div>}
    {permissions.rshsn && item?.operationUser && (
      <div>{`Пользователь: ${item.operationUser.fio}${
        item.operationDate ? ` (${item.operationDate.slice(0, 10)})` : ''
      }`}</div>
    )}
  </>
);
